module.exports = __webpack_public_path__ + "08_long_yellow.b6f7264f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/08_long_yellow.png
// module id = vngP
// module chunks = 0